// extracted by mini-css-extract-plugin
module.exports = {"avatarSuccess":"Header_avatarSuccess__T6jQY","avatarLoading":"Header_avatarLoading__1fUq7","userNameLoading":"Header_userNameLoading__16eq9"};